/* Server-rendered current-group prices only. No price fetching or cart-price override. */
(() => {
  'use strict';

  const initialized = new WeakSet();

  class DarnoxB2BOrder {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-dx-b2b-form]');
      this.host = root.querySelector('[data-dx-b2b-price-host]');
      this.variant = this.form?.querySelector('[name="id"]');
      this.quantity = this.form?.querySelector('[name="quantity"]');
      this.quantityLabel = this.form?.querySelector('[data-dx-b2b-quantity-label]');
      this.button = this.form?.querySelector('[data-dx-b2b-submit]');
      if (!this.form || !this.host || !this.variant || !this.quantity || !this.button) return;

      this.templates = new Map();
      root.querySelectorAll('template[data-dx-b2b-variant]').forEach((template) => {
        const id = template.dataset.dxB2bVariant;
        // A duplicate identity cannot choose a price by document order.
        this.templates.set(id, this.templates.has(id) ? null : template);
      });
      this.variant.addEventListener('change', () => this.update());
      this.quantity.addEventListener('input', () => this.updateControls());
      this.quantity.addEventListener('change', () => this.updateControls());
      this.form.addEventListener('submit', (event) => {
        // Recheck the selected ID even if another script changed it without an event.
        this.update();
        if (!this.orderable || !this.validQuantity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.orderable) this.quantity.reportValidity();
        }
      }, true);
      this.update();
      root.dataset.dxB2bControllerReady = 'true';
    }

    validQuantity() {
      const value = this.quantity.value;
      return /^\d+$/.test(value) && Number.isSafeInteger(Number(value)) && Number(value) >= 1;
    }

    update() {
      const selectedId = this.variant.value;
      const template = this.templates.get(selectedId);
      const panel = template?.content.querySelector('[data-dx-b2b-price-ready]');
      this.ready = Boolean(panel && panel.dataset.dxB2bVariantId === selectedId && panel.dataset.dxB2bPriceReady === 'true');
      this.orderable = this.ready && panel.dataset.dxB2bOrderable === 'true';

      if (panel && panel.dataset.dxB2bVariantId === selectedId) {
        this.host.replaceChildren(template.content.cloneNode(true));
      } else {
        const message = document.createElement('p');
        message.className = 'dx-b2b-order__gate';
        message.textContent = this.root.dataset.dxB2bNotReady;
        this.host.replaceChildren(message);
      }
      if (this.quantityLabel) {
        this.quantityLabel.textContent = this.ready ? panel.dataset.dxB2bQuantityLabel : this.root.dataset.dxB2bQuantity;
      }
      this.updateControls();
    }

    updateControls() {
      const validQuantity = this.validQuantity();
      this.quantity.min = '1';
      this.quantity.step = '1';
      this.quantity.disabled = !this.orderable;
      this.quantity.setCustomValidity(validQuantity ? '' : this.root.dataset.dxB2bIntegerQuantity);
      this.button.disabled = !this.orderable || !validQuantity;
      this.button.textContent = !this.ready ? this.root.dataset.dxB2bNotReady :
        (this.orderable ? this.root.dataset.dxB2bAdd : this.root.dataset.dxB2bSoldOut);
    }
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-dx-b2b-order]').forEach((root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
      new DarnoxB2BOrder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
